import AdminConfigTractorSprayProfiles from './AdminConfigTractorSprayProfiles';
export default AdminConfigTractorSprayProfiles;
